import {register} from '@shopify/theme-sections';

import initShopTheLook from '../components/shop-the-look';

export default register('images-row', {
  onLoad() {
    initShopTheLook(this.container);
  },
});
